import { GapFillStatusDescriptionMap } from "@app/projects/network-assessment/adequacy/gapFillStatusDescriptionMap";
import GapFillStatusHistoryTimeline from "@app/projects/network-assessment/GapFillStatusHistoryTimeline";
import { FC, ReactNode } from "react";

type GapFillStatusHistoryFlyoutProps = {
  customProjectId: number;
  projectRunConfigurationId: number;
  regionSetId: number;
  specialtyGroupCode: string;
  clearCacheImpactAnalysisRunConfigurations: () => void;
  gapFillDescriptionMap: GapFillStatusDescriptionMap;
} & { children?: ReactNode };

export const GapFillStatusHistoryFlyout: FC<React.PropsWithChildren<GapFillStatusHistoryFlyoutProps>> = (props: GapFillStatusHistoryFlyoutProps) => {
  return (
    <GapFillStatusHistoryTimeline
      customProjectId={props.customProjectId}
      projectRunConfigurationId={props.projectRunConfigurationId}
      regionSetId={props.regionSetId}
      specialtyGroupCode={props.specialtyGroupCode}
      clearCacheImpactAnalysisRunConfigurations={props.clearCacheImpactAnalysisRunConfigurations}
      gapFillStatusDescriptionMap={props.gapFillDescriptionMap}
    />
  );
}
